/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { mapModifiers } from 'libs/component';
import { Heading } from 'components/atoms/heading';
import Default from 'components/templates/default';
import { Section } from 'components/molecules/section';
import { VENUE_INFO_B2, VENUE_INFO_OPTION_LIST, VENUE_INFO_B1, VENUE_INFO_LG, VENUE_INFO_LM,VENUE_INFO_G, VENUE_INFO_1, VENUE_INFO_2} from 'libs/constants_info';
import { Waypoint } from 'react-waypoint';
import { useTranslation } from 'react-i18next';
import { OptionList } from 'components/molecules/option-list';
import { useEffect } from 'react';
import { Text } from 'components/atoms/text';

export interface GlanceProps {
  currentTab?: number;
  onOptionSelected?: (tab: number) => void;
  onNewsClick?: (slug: string) => void;
}

export const Glance: React.FC<GlanceProps> = ({ currentTab: defaultCurrentTab = 0, onOptionSelected}) => {
  const {t, i18n } = useTranslation();
  const [currentTab, setCurrentTab] = useState<number>(defaultCurrentTab);
  const [, setCurrentTopicIndex] = useState(0);
  // const menuRef = useRef(null);
  const policyRef = useRef(null);
  const optionList = useMemo(() => {
    return VENUE_INFO_OPTION_LIST;
  }, []);

  useEffect(() => {
    setCurrentTab(defaultCurrentTab);
  }, [setCurrentTab, defaultCurrentTab, currentTab]);

  const handleOptionSelected = useCallback(
    (index: number) => {
      setCurrentTab(index);
      if (onOptionSelected) {
        onOptionSelected(index);
      }
    },
    [setCurrentTab, onOptionSelected]
  );

  const venue_room_B2 = useMemo(() => {
    return VENUE_INFO_B2.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_B1 = useMemo(() => {
    return VENUE_INFO_B1.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);


  const venue_room_LG = useMemo(() => {
    return VENUE_INFO_LG.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);


  const venue_room_LM = useMemo(() => {
    return VENUE_INFO_LM.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_G = useMemo(() => {
    return VENUE_INFO_G.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const venue_room_1 = useMemo(() => {
    return VENUE_INFO_1.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);


  const venue_room_2 = useMemo(() => {
    return VENUE_INFO_2.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);


  const handleSectionEnter = useCallback((index: number) => {
    setCurrentTopicIndex(index);
  }, []);

  const optionItemList = optionList.map(x => (x.label as any)[i18n.language]);
  return (
    <div className={mapModifiers('t-privacy-policy')}>
      <Default>
        <article className="t-privacy-policy__content">
          <Section className="t-privacy-policy__heading">
            <Heading>场地信息</Heading>
            <div className="t-venue__description">
          <Text>
            <span
              dangerouslySetInnerHTML={{
                __html: t('venue.description'),
              }}
            />
          </Text>
          <br />
          <Text>{t('venue.scroll-text')}</Text>
        </div>
          </Section>
        

          {/* 楼层TAB */}
          <Section className="t-media__tabs">
            <OptionList
              currentIndex={currentTab}
              modifiers="horizontal"
              items={optionItemList}
              onSelected={handleOptionSelected}
            />
          </Section>

          {/* B2层 */}
          {currentTab === 0 && (
          <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {venue_room_B2.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail marginheight"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
           )}

            
      {currentTab === 1 && (
          <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {venue_room_B1.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail marginheight"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
           )}

      {currentTab === 2 && (
          <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {venue_room_LG.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail marginheight"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
        )}   

       {currentTab === 3 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_LM.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )}     

       
      {currentTab === 4 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_G.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )}  

      {currentTab === 5 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_1.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )}      


      {currentTab === 6 && (
          <Section className="t-privacy-policy__detail">
          <div className="t-privacy-policy__info" ref={policyRef}>
            {venue_room_2.map((policy: any, index: number) => (
              <div key={index} className="t-privacy-policy__info-detail-holder">
                <Waypoint onEnter={() => handleSectionEnter(index)} />
                <div
                  className="t-privacy-policy__info-detail marginheight"
                  dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                />
              </div>
            ))}
          </div>
          </Section>
        )} 

        {/* <div className={mapModifiers('t-venue__description')}>
            <div className="event "><a className="promotion" href='https://qsncc.com/en/visit/food-and-retail/' target=" _blank ">活动促销</a></div>

            <Text>
              <span
                dangerouslySetInnerHTML={{
                  __html: t('venue.promotion'),
                }}
              />
            </Text>
          </div> */}
    
         <div className='top20'></div>

        </article>
      </Default>
    </div>
  );
};
